<script>
	module.exports = {
		props: ['article', 'assessment', 'total-annotations', 'route-context'],

		components: {
			'content-body': require('components/content-body.vue').default
		},

		modelData: ['student'],

		data: function () {
			return {
				selectedArticle: null
			};
		},

		computed: {
			articleList() {
				let article = this.article;
				let assessment = this.assessment;
				let list = null;

				if (article && assessment) {
					list = assessment.options.sr.map(pid => article.articles[pid]);
				}

				return list;
			}
		},

		methods: {
			onArticleSelect: function (pid) {
				let article = this.article;
				if (article && article.articles) {
					this.selectedArticle = article.articles[pid];
				}
			}
		},

		watch: {
			articleList: {
				handler(val) {
					if (val && val.length) {
						this.onArticleSelect(val[0].uuid);
					}
				},
				immediate: true
			}
		}
	};
</script>
<template>
	<content-body
		class="wrapper"
		:article="article"
		:article-list="articleList"
		:selected-article="selectedArticle"
		:route-context="routeContext"
		:on-article-select="onArticleSelect"
		:show-audio="assessment && assessment.options.au"
		:student="student"
		:annotations="totalAnnotations"
		:has-workspace="!!assessment?.students[student]?.hasWorkspace"
		:step-read="true"></content-body>
</template>
